import React from 'react';
import { Outlet, useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ThemeSwitcher from './ThemeSwitcher';
import LanguageSelector from './LanguageSelector';

const Layout: React.FC = () => {
    const { t } = useTranslation();
    const location = useLocation();

    // Dynamic Title Logic
    const getTitle = () => {
        const path = location.pathname;

        if (path.includes('/game-master/')) {
            return t('header.gameMaster');
        }
        if (path.includes('/team-a/')) {
            return t('header.teamA');
        }
        if (path.includes('/team-b/')) {
            return t('header.teamB');
        }
        // Default title for Setup/Home
        return t('header.default');
    };

    return (
        <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-200">
            <header className="bg-blue-600 dark:bg-blue-800 text-white p-4 shadow-lg sticky top-0 z-50">
                <div className="container mx-auto flex justify-between items-center">
                    <h1 className="text-xl md:text-2xl font-bold truncate">
                        {getTitle()}
                    </h1>
                    <div className="flex gap-2 shrink-0">
                        <LanguageSelector />
                        <ThemeSwitcher />
                    </div>
                </div>
            </header>
            <main className="container mx-auto p-4">
                <Outlet />
            </main>
        </div>
    );
};

export default Layout;
